// extracted by mini-css-extract-plugin
export default {"headerclass":"allTable_headerclass__9LuhH","headerText":"allTable_headerText__6moVX","rowText":"allTable_rowText__9h6Wk"};